// extracted by mini-css-extract-plugin
export default {"MarketplaceDeckContainer":"marketplace-deck-container_MarketplaceDeckContainer__2vNsL"};